import {Types} from "@Common/types";

export const CA_PROVINCES:Types.Common.UiComponents.Heavy.Common.CanadaProvinces = require("./canada-provinces.json");

